import { z } from 'zod'

export const webhookEventTypeSchema = z.enum([
  'note_generation.succeeded',
  'note_generation.failed',
  'audio_transcription.succeeded',
  'audio_transcription.failed',
  'coding.succeeded',
  'coding.failed',
  'consensus.succeeded',
  'consensus.failed',
  'note_template_generation.succeeded',
  'note_template_generation.failed',
])

export type WebhookEventType = z.infer<typeof webhookEventTypeSchema>
